import React from 'react';
import { Insights, AutoFixHigh, MenuBook, Spellcheck, Campaign } from '@mui/icons-material';

export interface MainCardData {
  icon: React.ReactNode;
  shortTitle: string;
  description: string;
  prompt: string;
}

export const mainCards: MainCardData[] = [
  {
    icon: <Insights fontSize="small" />,
    shortTitle: 'Market Trends',
    description: 'Researcher agent analyses the market trends and identify growing and potential (sunrise) industries.',
    prompt: `Analyze current market trends and identify growing and potential industries, also known as sunrise industries, with a specific focus on the industrial fastening and assembly technology sector.

Please consider the following aspects in your analysis:
- Economic Indicators: Examine key economic indicators such as GDP growth rates, employment rates, and consumer spending patterns.
- Technological Advancements: Identify industries benefiting from recent technological innovations and breakthroughs, particularly in fastening and assembly technology.
- Consumer Behavior: Analyze shifts in consumer preferences and behaviors that are driving demand in sectors related to industrial fastening and assembly.
- Regulatory Environment: Consider the impact of government policies, regulations, and incentives on the industrial fastening and assembly technology industry.
- Global Trends: Take into account global economic trends, trade dynamics, and geopolitical factors affecting the industry.
- Sustainability and Environmental Impact: Evaluate industries that are focusing on sustainability and have a positive environmental impact, especially in the context of industrial fastening and assembly.
- Investment and Funding: Look at trends in venture capital, private equity, and other forms of investment that indicate growing interest in the industrial fastening and assembly technology sector.

Provide a comprehensive report that includes:
- A report title.
- A summary of the current market landscape.
- Identification of the top 5 growing and potential industries within the context of industrial fastening and assembly technology.
- Detailed analysis of each identified industry, including key drivers, challenges, and future outlook.
- Recommendations for businesses and investors looking to enter or expand in these industries.`,
  },
  {
    icon: <AutoFixHigh fontSize="small" />,
    shortTitle: 'Prompt Helper',
    description: 'This prompt helps using AI to help generate other prompts',
    prompt: `I want you to act as a GPT prompt generator. Take this topic "XXX" and generate a GPT prompt based on the content of the topic.

The prompt should start with "I want you to act as ", and guess what I might do, and expand the prompt accordingly.`,
  },
  {
    icon: <MenuBook fontSize="small" />,
    shortTitle: 'Get Summary',
    description: 'This prompt helps with providing Wikipedia like summarizations of a topic.',
    prompt: `I want you to act as a Wikipedia page. I will give you the name of a topic, and you will provide a summary of that topic in the format of a Wikipedia page. Your summary should be informative and factual, covering the most important aspects of the topic. Start your summary with an introductory paragraph that gives an overview of the topic. Topic: "XXX".`,
  },
  {
    icon: <Spellcheck fontSize="small" />,
    shortTitle: 'Proofreading',
    description: 'This prompt helps with proofreading content.',
    prompt: `I want you act as a proofreader. I will provide you with a block of text and I would like you to review the text for any spelling, grammar, or punctuation errors. Once you have finished reviewing the text, provide me with any necessary corrections or suggestions to improve the text.
Text: "XXX"`,
  },
  {
    icon: <Campaign fontSize="small" />,
    shortTitle: 'Marketing Strategy',
    description: 'This prompt helps to develop a marketing strategy from product information',
    prompt: `Formulate a marketing strategy for this product, service or event "XXX", targeting the specified "audience".`,
  },
];

export default mainCards;
